export const common = {
  nav: {
    home: 'Home',
    ourPuppies: 'Our Puppies',
    accessories: 'Accessories',
    boarding: 'Puppy Boarding',
    aboutUs: 'About Us',
    contactUs: 'Contact Us'
  },
  hero: {
    title: 'Find Your Perfect',
    titleHighlight: 'Furry Friend',
    subtitle: 'Premium Poodles and Maltipoos raised with love and care. Healthy, happy puppies ready to join your family.',
    viewPuppies: 'View Available Puppies',
    contact: 'Contact Us',
    yearsExperience: 'Years Experience',
    happyFamilies: 'Happy Families',
    healthGuarantee: 'Health Guarantee'
  },
  puppies: {
    title: 'Available',
    titleHighlight: 'Puppies',
    subtitle: 'Meet our adorable puppies looking for their forever homes. Each one is health-checked, vaccinated, and ready to bring joy to your family.',
    allPuppies: 'All Puppies',
    poodles: 'Poodles',
    maltipoos: 'Maltipoos',
    available: 'Available',
    notAvailable: 'Not Available',
    inquireNow: 'Inquire Now',
    age: 'old',
    male: 'Male',
    female: 'Female'
  },
  about: {
    title: 'About',
    titleHighlight: 'Dog Store',
    intro: 'Welcome to Dog Store, where we\'ve been breeding premium Poodles and Maltipoos for over a decade. Our passion is raising healthy, happy puppies in a loving home environment.',
    paragraph1: 'Every puppy is raised with exceptional care, proper socialization, and receives comprehensive health screenings. We believe in responsible breeding practices and are committed to matching each puppy with the perfect family.',
    paragraph2: 'Our Poodles and Maltipoos are known for their intelligence, affectionate nature, and hypoallergenic coats, making them ideal companions for families, seniors, and individuals alike.',
    healthGuarantee: 'Health Guarantee',
    healthGuaranteeDesc: 'All puppies come with comprehensive health certificates and guarantees',
    lifetimeSupport: 'Lifetime Support',
    lifetimeSupportDesc: 'We\'re here for you and your puppy throughout their entire life'
  },
  whyChoose: {
    title: 'Why Choose',
    titleHighlight: 'Dog Store',
    subtitle: 'We\'re committed to breeding excellence and providing families with healthy, happy puppies. Here\'s what sets us apart from other breeders.',
    healthCertified: 'Health Certified',
    healthCertifiedDesc: 'All puppies receive comprehensive veterinary examinations, vaccinations, and health certificates before going home.',
    championBloodlines: 'Champion Bloodlines',
    championBloodlinesDesc: 'Our breeding dogs come from champion bloodlines with excellent temperaments and health histories.',
    homeRaised: 'Home Raised',
    homeRaisedDesc: 'Puppies are raised in our home with daily socialization, ensuring well-adjusted and friendly companions.',
    completeDocumentation: 'Complete Documentation',
    completeDocumentationDesc: 'Registration papers, health records, vaccination history, and care instructions included with every puppy.',
    ongoingSupport: 'Ongoing Support',
    ongoingSupportDesc: 'We provide lifetime breeder support and are always available to answer questions about your puppy.',
    puppyStarterKit: 'Puppy Starter Kit',
    puppyStarterKitDesc: 'Each puppy goes home with food, toys, blanket with littermate scent, and care essentials to ease the transition.',
    ctaTitle: 'Ready to Welcome a New Family Member?',
    ctaSubtitle: 'Our puppies are in high demand. Reserve your perfect companion today!',
    ctaButton: 'Get in Touch'
  },
  testimonials: {
    title: 'Happy',
    titleHighlight: 'Families',
    subtitle: 'Don\'t just take our word for it. Here\'s what our happy customers have to say about their experience with PawfectPups and their new furry family members.'
  },
  contact: {
    title: 'Get in',
    titleHighlight: 'Touch',
    subtitle: 'Interested in one of our adorable puppies? Have questions about our breeding program? We\'d love to hear from you! Fill out the form and we\'ll get back to you within 24 hours.',
    phone: 'Phone',
    phoneSchedule: 'Mon-Sat: 9AM - 6PM',
    email: 'Email',
    emailResponse: 'We reply within 24 hours',
    location: 'Location',
    locationCity: 'Moscow, Russia',
    fullName: 'Full Name',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    interestedIn: 'Interested In',
    selectBreed: 'Select a breed',
    toyPoodle: 'Toy Poodle',
    miniaturePoodle: 'Miniature Poodle',
    maltipoo: 'Maltipoo',
    notSure: 'Not Sure Yet',
    message: 'Message',
    messagePlaceholder: 'Tell us about yourself and what you\'re looking for in a puppy...',
    charactersLimit: 'characters',
    sendMessage: 'Send Message',
    sending: 'Sending...',
    successMessage: 'Thank you! We\'ll get back to you within 24 hours.',
    errorMessage: 'Something went wrong. Please try again.'
  },
  footer: {
    description: 'Premium Poodles and Maltipoos bred with love and care. Your trusted source for healthy, happy puppies.',
    quickLinks: 'Quick Links',
    home: 'Home',
    availablePuppies: 'Available Puppies',
    aboutUs: 'About Us',
    contact: 'Contact',
    ourBreeds: 'Our Breeds',
    toyPoodles: 'Toy Poodles',
    miniaturePoodles: 'Miniature Poodles',
    maltipoos: 'Maltipoos',
    championBloodlines: 'Champion Bloodlines',
    healthCertified: 'Health Certified',
    contactInfo: 'Contact Info',
    schedule: 'Mon-Sat: 9AM - 6PM',
    locationCity: 'Moscow, Russia',
    copyright: '© 2024 Dog Store. All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    websiteBuilder: 'Website Builder'
  },
  accessories: {
    title: 'Luxury',
    titleHighlight: 'Accessories',
    subtitle: 'Pamper your precious pup with our exclusive collection of glamorous accessories',
    comingSoon: 'Coming Soon',
    comingSoonDescription: 'We\'re preparing an exclusive collection of luxury accessories for your beloved puppies. Stay tuned!',
    categories: {
      collars: 'Collars',
      beds: 'Beds',
      bowls: 'Bowls',
      carriers: 'Carriers',
      clothing: 'Clothing',
      grooming: 'Grooming',
      toys: 'Toys',
      leashes: 'Leashes',
    },
    items: {
      luxuryCollar: {
        name: 'Crystal Elegance Collar',
        description: 'Handcrafted with Swarovski crystals and premium velvet',
      },
      plushBed: {
        name: 'Royal Velvet Bed',
        description: 'Ultra-soft velvet with gold-trimmed edges',
      },
      crystalBowl: {
        name: 'Golden Dining Set',
        description: 'Ceramic bowls with 24k gold accents',
      },
      designerCarrier: {
        name: 'Luxury Travel Carrier',
        description: 'Designer carrier with plush interior',
      },
      silkBandana: {
        name: 'Silk Bandana Collection',
        description: 'Premium silk with elegant patterns',
      },
      groomingKit: {
        name: 'Spa Grooming Kit',
        description: 'Professional tools in luxury case',
      },
      toySet: {
        name: 'Plush Toy Collection',
        description: 'Handmade toys with safe materials',
      },
      leatherLeash: {
        name: 'Premium Leather Leash',
        description: 'Italian leather with gold hardware',
      },
    },
    addToCart: 'Add to Cart',
    specialOffer: {
      title: 'Special Bundle Offer',
      description: 'Get 20% off when you purchase accessories with your new puppy!',
      button: 'Shop Bundles',
    },
    notifyMe: {
      title: 'Get Notified',
      description: 'Be the first to know when our luxury accessories collection launches!',
      button: 'Notify Me',
    },
  },
  boarding: {
    title: 'Puppy',
    titleHighlight: 'Boarding',
    subtitle: 'Going on vacation? We provide premium boarding services for your beloved puppies with 24/7 care, comfortable accommodations, and daily updates.',
    formTitle: 'Book Your Puppy\'s Stay',
    ownerName: 'Your Name',
    email: 'Email',
    phone: 'Phone',
    puppyName: 'Puppy\'s Name',
    breed: 'Breed',
    selectBreed: 'Select breed',
    poodle: 'Poodle',
    maltipoo: 'Maltipoo',
    other: 'Other',
    checkInDate: 'Check-in Date',
    checkOutDate: 'Check-out Date',
    specialRequirements: 'Special Requirements',
    specialRequirementsPlaceholder: 'Any special dietary needs, medications, or care instructions...',
    submitBooking: 'Submit Booking',
    submitting: 'Submitting...',
    successMessage: 'Thank you! Your booking request has been received. We\'ll contact you within 24 hours to confirm.',
    errorMessage: 'Something went wrong. Please check all required fields and try again.',
    feature1Title: 'Luxury Accommodations',
    feature1Desc: 'Spacious, climate-controlled rooms with comfortable bedding and toys',
    feature2Title: '24/7 Professional Care',
    feature2Desc: 'Experienced staff providing round-the-clock attention and care',
    feature3Title: 'Daily Photo Updates',
    feature3Desc: 'Receive photos and updates of your puppy every day during their stay'
  }
};
